(function () {
    'use strict';

    angular
        .module('awizApp')
        .component('daysOff', {
            bindings: {
                year: '<',
                items: '<'
            },
            templateUrl: 'app/entities/day-off/list.html',
            controller: function ($state, DayOff, DayOffDialogService, ConfirmDialogService, AlertService) {
                var ctrl = this;

                ctrl.$onInit = function () {
                    ctrl.selectedYear = parseInt(ctrl.year, 10);
                };

                ctrl.selectYear = function () {
                    var year = parseInt(ctrl.selectedYear, 10);
                    if (year >= 2020 && year <= 2100) {
                        $state.go('dayOff', {year: year});
                    }
                };

                ctrl.changeYear = function (offset) {
                    ctrl.selectedYear = parseInt(ctrl.selectedYear, 10) + offset;
                    ctrl.selectYear();
                };

                ctrl.importYear = function () {
                    var year = parseInt(ctrl.selectedYear, 10);
                    return ConfirmDialogService.open({
                        messageTranslated: {
                            key: 'dayOff.importQuestion',
                            params: {year: year}
                        },
                        confirmPromise: function () {
                            return DayOff.importYear({year: year}, {}).$promise.then(function (result) {
                                AlertService.success('dayOff.importSuccess', {
                                    year: result.year,
                                    importedCount: result.importedCount,
                                    skippedCount: result.skippedCount,
                                    availableCount: result.availableCount
                                });
                            });
                        }
                    }).then(reload);
                };

                ctrl.create = function () {
                    DayOffDialogService.open({id: null, date: moment().format('YYYY-MM-DD')}).then(reload);
                };

                ctrl.edit = function (item) {
                    DayOffDialogService.open(item).then(reload);
                };

                ctrl.delete = function (item) {
                    ConfirmDialogService.open({
                        messageTranslated: {
                            key: 'dayOff.deleteQuestion',
                            params: {param: item.date}
                        },
                        confirmPromise: function () {
                            return DayOff.delete({id: item.id}).$promise;
                        }
                    }).then(reload);
                };

                function reload() {
                    return $state.reload();
                }
            }
        })
        .config(function ($stateProvider) {
            $stateProvider.state('dayOff', {
                parent: 'entity',
                url: '/day-off?{year:int}',
                data: {
                    authorities: ['ROLE_OWNER']
                },
                views: {
                    'content@': 'daysOff'
                },
                params: {
                    year: {
                        value: moment().year(),
                        squash: true
                    }
                },
                resolve: {
                    year: function ($transition$) {
                        return selectedYear($transition$);
                    },
                    items: function (DayOff, $transition$) {
                        return DayOff.query({year: selectedYear($transition$)}).$promise;
                    }
                }
            });

            function selectedYear($transition$) {
                var year = parseInt($transition$.params().year, 10);
                return isNaN(year) ? moment().year() : year;
            }
        });
})();
